import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const LaserIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
    // sx={{ fill: 'none' }}
  >
    <path
      d="M17.45 3.17973C17.45 2.37339 16.7986 1.71973 15.995 1.71973C15.1915 1.71973 14.54 2.37339 14.54 3.17973V8.35973C14.54 9.16606 15.1915 9.81973 15.995 9.81973C16.7986 9.81973 17.45 9.16606 17.45 8.35973V3.17973Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M16 17.71C16.9444 17.71 17.71 16.9444 17.71 16C17.71 15.0556 16.9444 14.29 16 14.29C15.0556 14.29 14.29 15.0556 14.29 16C14.29 16.9444 15.0556 17.71 16 17.71Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M17.45 3.17973C17.45 2.37339 16.7986 1.71973 15.995 1.71973C15.1915 1.71973 14.54 2.37339 14.54 3.17973V8.35973C14.54 9.16606 15.1915 9.81973 15.995 9.81973C16.7986 9.81973 17.45 9.16606 17.45 8.35973V3.17973Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M26.0888 7.96799C26.6589 7.39782 26.6605 6.47498 26.0923 5.90677C25.5241 5.33856 24.6013 5.34014 24.0311 5.91031L20.3683 9.57312C19.7981 10.1433 19.7965 11.0661 20.3648 11.6343C20.933 12.2025 21.8558 12.201 22.426 11.6308L26.0888 7.96799Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M28.8203 17.45C29.6266 17.45 30.2803 16.7986 30.2803 15.995C30.2803 15.1915 29.6266 14.54 28.8203 14.54H23.6403C22.8339 14.54 22.1803 15.1915 22.1803 15.995C22.1803 16.7986 22.8339 17.45 23.6403 17.45H28.8203Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M24.0369 26.0937C24.6071 26.6638 25.5299 26.6654 26.0981 26.0972C26.6663 25.529 26.6647 24.6061 26.0946 24.036L22.4318 20.3732C21.8616 19.803 20.9388 19.8014 20.3705 20.3696C19.8023 20.9378 19.8039 21.8607 20.3741 22.4309L24.0369 26.0937Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M14.55 28.8203C14.55 29.6266 15.2014 30.2803 16.005 30.2803C16.8085 30.2803 17.46 29.6266 17.46 28.8203V23.6403C17.46 22.8339 16.8085 22.1803 16.005 22.1803C15.2014 22.1803 14.55 22.8339 14.55 23.6403V28.8203Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M5.90829 24.0389C5.33812 24.609 5.33654 25.5319 5.90475 26.1001C6.47297 26.6683 7.3958 26.6667 7.96597 26.0965L11.6288 22.4337C12.1989 21.8636 12.2005 20.9407 11.6323 20.3725C11.0641 19.8043 10.1413 19.8059 9.5711 20.376L5.90829 24.0389Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M3.17973 14.55C2.37339 14.55 1.71973 15.2014 1.71973 16.005C1.71973 16.8085 2.37339 17.46 3.17973 17.46H8.35973C9.16606 17.46 9.81973 16.8085 9.81973 16.005C9.81973 15.2014 9.16606 14.55 8.35973 14.55H3.17973Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
    <path
      d="M7.96701 5.91317C7.39684 5.34301 6.47401 5.34142 5.90579 5.90964C5.33758 6.47785 5.33916 7.40069 5.90933 7.97085L9.57214 11.6337C10.1423 12.2038 11.0651 12.2054 11.6334 11.6372C12.2016 11.069 12.2 10.1462 11.6298 9.57598L7.96701 5.91317Z"
      fill="white"
      fillOpacity="0.2"
      stroke="white"
      strokeWidth="1.33"
      strokeMiterlimit="10"
    />
  </SvgIcon>
);
